import { createSelector } from "../../../utils/createSelector.js";
export var COMPACT_DENSITY_FACTOR = 0.7;
export var COMFORTABLE_DENSITY_FACTOR = 1.3;
var DENSITY_FACTORS = {
    compact: COMPACT_DENSITY_FACTOR,
    comfortable: COMFORTABLE_DENSITY_FACTOR,
    standard: 1
};
export var gridDensitySelector = function(state) {
    return state.density;
};
export var gridDensityFactorSelector = createSelector(gridDensitySelector, function(density) {
    return DENSITY_FACTORS[density];
});
